import React from 'react';
import { usePWA } from './use-mobile';

export function usePWABanner() {
  const { isInstallable, isInstalled } = usePWA();
  
  const [dismissed, setDismissed] = React.useState(() => {
    return sessionStorage.getItem('pwa-banner-dismissed') === 'true';
  });

  // Banner is visible if app is installable, not installed, and not dismissed
  const isBannerVisible = isInstallable && !isInstalled && !dismissed;

  return {
    isBannerVisible,
    dismissed,
    setDismissed
  };
}
